define(
    'viewmodels/secured/explorer/details/tabs/preview/preview',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "viewmodels/controller"
    ],
    function (ViewModel, dataProvider, controller) {
        var _documentPreviews = [];

        var _go = 0;

        var vm = new ViewModel(
        {
            isActiveTab: ko.observable(false),
            documentId: '',
        });

        vm.load = function (document) {
            if (!vm.isActiveTab()) {
                return;
            }

            if (document) {
                vm.documentId = document.documentId;

                preview(document.documentId, false);

            } else {
                try {
                    var iframe = window.document.getElementById('preview-iframe');
                    if (!iframe) {
                        //console.error("preview-iframe does not exist");
                        return;
                    }
                    var w = iframe.contentWindow || iframe.contentDocument;

                    if (w && w.document) {
                        var wdoc = w.document;

                        wdoc.open();
                        wdoc.clear();
                        wdoc.write('');
                        wdoc.close();
                    }
                }
                catch (ex) {
                    console.error(ex);
                }
            }
        };
        vm.refresh = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                preview(vm.documentId, true);

                complete();
            }
        });

        function preview(documentId, refresh) {
            refresh = refresh || false;

            _cacheGetPreview(documentId, refresh)
            .done(function (result) {
                var iframe = window.document.getElementById('preview-iframe');

                if (!iframe)
                    return;

                var w = iframe.contentWindow || iframe.contentDocument;

                if (w && w.document) {
                    var wdoc = w.document;
                    
                    wdoc.open();
                    wdoc.clear();

                    //ALSO IN DOWNLOAD PREVIEW
                    try {
                        if (result.encoding.indexOf('text/html') != -1) {
                            wdoc.write(decodeURI(result.data));

                            var span = wdoc.getElementsByClassName('auto-style1');
                            if (span.length) span[0].style.width = "auto";
                        }
                        else if (result.encoding.indexOf('text/plain') != -1) {
                            wdoc.write(decodeURI(result.data));
                        }
                        else if (result.encoding.indexOf('image/') != -1) {
                            wdoc.write('<img style="display:block;" src="' + String.format("{0}{1}", result.encoding, result.data) + '"></img>');
                        }
                        else {
                            wdoc.write('unidentified encoding');
                            console.warn('unidentified encoding : ' + result.encoding);
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }

                    wdoc.close();
                }
            })
            .fail(function (e) {
                e.stopPropagation = true;
            });
        }
        
        return vm;

        function _cacheGetPreview(documentId, refresh) {
            var d = $.Deferred();

            refresh = refresh || false;

            var f = _.find(_documentPreviews, function (itm) { return !itm ? false : itm.documentId == documentId; });
            if (refresh)
                _documentPreviews = _.without(_documentPreviews, f);

            if (f && !refresh) {
                d.resolve(f);
            } else {
                controller.isBusy(true);

                dataProvider.documents
                .getDocumentPreview(documentId)
                .done(function (results) {
                    results.documentId = documentId;
                    
                    _documentPreviews.push(results);

                    d.resolve(results);
                })
                .fail(function (e) {
                    d.reject(e);

                    console.error(e);
                })
                .always(function () {
                    controller.isBusy(false);
                });
            }

            return d.promise();
        }
    });

